// extracted by mini-css-extract-plugin
export default {"sidebar_collapse":"SidebarCollapseExercise_sidebar_collapse__60QV8","sidebar_toggle":"SidebarCollapseExercise_sidebar_toggle__5sptW","open":"SidebarCollapseExercise_open__lo2xS"};